<template>
  <sandboxNavigation />
  <!-- comment until needed -->
  <ReloadPWA v-if="pwaEnabled" />
  <Chat/>
  <!-- component matched by the route will render here -->

  <router-view></router-view>

  <ModalsContainer />
  <InstallPWA  v-if="pwaEnabled" />
</template>

<script setup>
  const _customer = import.meta.env.VITE_CUSTOMER
  const pwaEnabled = import.meta.env.VITE_ENABLE_PWA === 'true'

  import './assets/scss/main.scss'

  // Dynamically import customer-specific styles
  import(`./_customer/${_customer}/styles/styles.scss`).catch((err) => {
    console.warn(`Customer styles not found for ${_customer}`, err)
  })

  import { defineAsyncComponent, onMounted } from 'vue'
  import { debounce, triggerEvent } from './helpers/helpers.js'
  import InstallPWA from './components/install-pwa.vue'

  // comment until needed
  import ReloadPWA from './components/reload-pwa.vue'
  import { ModalsContainer } from 'vue-final-modal'

  const Chat = defineAsyncComponent(() => {
    if (import.meta.env.VITE_ENABLE_CHAT === 'true') {
      return import("@/components/chat/chat.vue");
    }

    return Promise.resolve(() => null);
  });

  const sandboxNavigation = defineAsyncComponent(() => {
    if (import.meta.env.VITE_SANDBOX_NAVIGATION_ENABLED === 'true') {
      return import('@/components/_sandbox/sandbox-navigation.vue');
    }
    return Promise.resolve(() => null);
  });

  onMounted(() => {
    window.addEventListener('resize', debounce(() => triggerEvent(window, 'resize:smart'), 250));
  })
</script>
